import { LayerContextProvider, Portal } from "@smartsheet/lodestar-core";
import React from "react";
export const ToastPortal = _ref => {
  let {
    children,
    element
  } = _ref;
  if (!element) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement(Portal, {
      appendTo: element
    }, /*#__PURE__*/React.createElement(LayerContextProvider, {
      defaultLayer: "toast"
    }, children));
  }
};
//# sourceMappingURL=ToastPortal.js.map